import { styled } from '@mui/material/styles';

export const StyledFloatingTicketWrapper = styled('div')(() => ({
  width: '100%',
}));

export const StyledFloatingHeaderWrapper = styled('div')(({ theme }) => ({
  backgroundColor: theme?.palette.grey?.bt_alt_grey_light,
  borderTopLeftRadius: theme?.shape?.border?.borderRadius,
  borderTopRightRadius: theme?.shape?.border?.borderRadius,
  position: 'relative',
  padding: '15px 24px 22px',
}));

const loaderDefaultStyle = {
  position: 'absolute',
  zIndex: 10,
  left: 0,
  right: 0,
  bottom: 0,
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
};

export const StyledLoader = styled('div')(({ theme }) => ({
  ...loaderDefaultStyle,
  top: 0,
  marginTop: '153px',
  marginBottom: '80px',
  backgroundColor: theme?.palette.generic?.primary,
}));

export const StyledLoaderHeader = styled('div')(({ theme }) => ({
  ...loaderDefaultStyle,
  top: 0,
  height: '153px',
  backgroundColor: theme?.palette.grey?.bt_alt_grey_light,
  borderRadius: '10px 10px 0 0',
}));

export const StyledLoaderFooter = styled('div')(({ theme }) => ({
  ...loaderDefaultStyle,
  height: '80px',
  borderTop: `1px solid ${theme?.palette.grey?.bt_alt_grey_hover}`,
  backgroundColor: theme?.palette.generic?.primary,
}));
